var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 3.33337C13.3333 4.43794 10.9455 5.33337 7.99999 5.33337C5.05447 5.33337 2.66666 4.43794 2.66666 3.33337M13.3333 3.33337C13.3333 2.2288 10.9455 1.33337 7.99999 1.33337C5.05447 1.33337 2.66666 2.2288 2.66666 3.33337M13.3333 3.33337V12.6667C13.3333 13.7713 10.9455 14.6667 7.99999 14.6667C5.05447 14.6667 2.66666 13.7713 2.66666 12.6667V3.33337M13.3333 6.44444C13.3333 7.54901 10.9455 8.44444 7.99999 8.44444C5.05447 8.44444 2.66666 7.54901 2.66666 6.44444M13.3333 9.55337C13.3333 10.6579 10.9455 11.5534 7.99999 11.5534C5.05447 11.5534 2.66666 10.6579 2.66666 9.55337",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCoin);
export default __webpack_public_path__ + "static/media/ic_coin.169afe00df4bc30248f6ec91cad1620b.svg";
export { ForwardRef as ReactComponent };